import template from './questionnairePreview.html';
import QuestionnairePreviewCtrl from './questionnairePreviewCtrl';

export default {
  template,
  controller: QuestionnairePreviewCtrl,
  controllerAs: 'vm',
};
